import { useSyncExternalStore } from 'react';
import { getPointCampaignBoardSnapshot, subscribePointCampaignBoard } from '../services/pointCampaignBoardStore';

/**
 * 全画面共通のptキャンペーンの掲示を購読する
 * @returns {ReturnType<typeof getPointCampaignBoardSnapshot>} 掲示
 */
const usePointCampaignBoard = () => useSyncExternalStore(
  subscribePointCampaignBoard,
  getPointCampaignBoardSnapshot,
  getPointCampaignBoardSnapshot,
);

export default usePointCampaignBoard;
